import HeaderButton from '@molecules/HeaderButton';
import { defaultBack } from '@utils/navigation';
import { headerOptionsCreator } from '@utils/screenOptions';
import { Stack } from 'expo-router';
import React from 'react';

export default function ProfileLayout() {
  return (
    <Stack screenOptions={headerOptionsCreator()}>
      <Stack.Screen
        name="index"
        options={headerOptionsCreator(<HeaderButton onPress={defaultBack()} />)}
      />
      <Stack.Screen
        name="tickets"
        options={headerOptionsCreator(<HeaderButton onPress={defaultBack()} />)}
      />
    </Stack>
  );
}
